export default "__VITE_ASSET__DfzR4ipq__"